import * as React from "react";
import Select from "react-select";
import { OperatorRoleTypes } from "../../../../interfaces/OperatorInterface";
import styles from "./styles.scss";

interface Props {
  operatorId: string;
  role: string;
  isPending: boolean;
  currentOperatorId: string;
  onRoleChange: (value: OperatorRoleTypes) => void;
}

const RoleSelect: React.FC<Props> = ({
  operatorId,
  role,
  isPending,
  currentOperatorId,
  onRoleChange,
}) => {
  if (operatorId === currentOperatorId) {
    return null;
  }

  const options = [
    { value: "admin", label: "管理者" },
    { value: "member", label: "メンバー" },
  ] as const;

  return (
    <Select
      className={styles.select}
      options={options}
      isClearable={false}
      isSearchable={false}
      isLoading={isPending}
      isDisabled={isPending}
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      value={options.find((option) => option.label === role)}
      onChange={(value) => {
        if (value == null) {
          return;
        }
        onRoleChange(value.value);
      }}
    />
  );
};

export default RoleSelect;
